export function plotBars(countedPoints) {
  const amounts = countedPoints.map(p => p.amount);
  const maxAmount = Math.max(...amounts);
  const minAmount = Math.min(...amounts);
  return countedPoints.map(point => {
    const normalizedAmount = point.amount - minAmount;
    const height = normalizedAmount * 100 / (maxAmount - minAmount);
    return {
      value: point.from,
      height
    };
  });
}